exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".errorScreen[data-v-25fc85d9]{align-items:center;text-align:center;flex-direction:column;padding-top:60px}.buttonWrapper[data-v-25fc85d9]{padding-top:40px}p[data-v-25fc85d9]{padding-bottom:60px}\n", ""]);
